export const BANNER_HEIGHT = 54;
export const VERTICAL_PADDING = 9;

export const ROCKET_ICON = "/images/trial-modal/rocket.svg";

export const LOCAL_STORAGE_KEY = `TopBanner___last-displayed`;

export const DAY_TIMESTAMP = 24 * 60 * 60;
